import { env } from '@/env';

/**
 * La rotta `backgammon/live/:id` esiste in QUESTA build solo con i due flag (`routes/router.tsx`: sta dentro
 * `backgammonRoutes`, che e' dentro `featureBackgammonEnabled`, e ha il suo `featureBackgammonLiveEnabled`).
 * UNA definizione, letta da «Guarda» (`components/social/GuardaLive.tsx`) e dall'atterraggio del deep link `guarda_bg_<uuid>`
 * (`hooks/usePendingInvite.ts`): due copie di questa riga divergerebbero in silenzio, e un bottone verso una rotta che non c'e'
 * e' un vicolo cieco. Il ruolo `beta` non sta qui: lo leggono i due chiamanti, ciascuno dal suo posto.
 */
export const rottaBackgammonLiveInBuild = (): boolean =>
  env.featureBackgammonEnabled && env.featureBackgammonLiveEnabled;
